import React from 'react';
import styled from 'styled-components/macro';
import { Link } from 'react-router-dom';
import { Field, reduxForm } from 'redux-form';
import { renderField } from '../../../form_helpers';
import { Button as ButtonV2 } from '../../../v2/components/button/Button';

const validate = (values, props) => {
  const errors = {};
  if (!values.email) {
    errors.email = props.strings.required;
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,5}$/i.test(values.email)) {
    errors.email = props.strings.invalidEmail;
  }

  if (!values.password) {
    errors.password = props.strings.required;
  }
  return errors;
};

let SignInForm = (props) => {
  const strings = props.strings;
  const { handleSubmit, submitting } = props;
  return (
    <div className="form form--no-btm-pad">
      <form className="form__form" onSubmit={handleSubmit}>
        <Field
          name="email"
          type="email"
          component={renderField}
          placeholder={strings.email}
          label={strings.email}
          autoFocus={true}
        />
        <Field
          name="password"
          type="password"
          component={renderField}
          placeholder={strings.password}
          label={strings.password}
        />
        {props.children}
        <div className="form__actions">
          <ButtonV2
            onClick={handleSubmit}
            label={strings.logIn}
            size="large"
            disabled={submitting}
          />
          <ButtonSubmit aria-hidden="true" />
        </div>
      </form>
      <FormInstruct>
        <H6>{strings.loginInstructionNew}</H6>
        <Link to="/MyS4C/SignUp">{strings.signUpNow}</Link>
      </FormInstruct>
    </div>
  );
};

const FormInstruct = styled.div`
  margin: 32px 20px 24px;
  padding: 24px 20px;
  background-color: ${(props) =>
    props.theme.name === 'light'
      ? 'rgba(16, 16, 15, 0.025);'
      : 'rgba(251, 251, 251, 0.025);'};
  border-radius: 8px;
  font-size: 20px;
  line-height: 24px;

  a {
    position: relative;
    display: inline-block;
    font-weight: bold;
    &:focus-visible {
      box-shadow: ${(props) => props.theme.focusRing};
      border-radius: 4px;
      outline: none;
    }
    &:focus:not(:focus-visible) {
      outline: none;
    }
    &:after {
      position: absolute;
      width: 100%;
      height: 1px;
      background-color: ${(props) =>
        props.theme.name === 'light'
          ? props.theme.color.primaryAAA
          : props.theme.color.primaryFull};
      bottom: 0;
      left: 0;
      content: '';
    }
  }
`;

const H6 = styled.h6`
  margin: 0 0 0.6em;
  font-size: 20px;
  font-weight: normal;
  line-height: 24px;
  color: ${(props) =>
    props.theme.name === 'light'
      ? props.theme.color.blackFull
      : props.theme.color.whiteFull};
`;

const ButtonSubmit = styled.button`
  position: absolute;
  left: -9999px;
`;

SignInForm = reduxForm({
  form: 'signin',
  validate,
})(SignInForm);

export default SignInForm;
